import CreateForm from '../components/CreateStudyComponents/CreateForm.js';

function CreateStudyPage() {
  return (
    <>
      <CreateForm />
    </>
  );
}

export default CreateStudyPage;
